<div class="spinner-wrapper">
    <div class="spinner sk-spinner-pulse"></div>
  </div>